import TextField from "@/component/widgets/text-field";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { ListData } from "@/entry/server/user";
import { userRepo } from "@/repo/user-repo";
import React, { useContext, useEffect, useRef, useState } from "react";
import searchIcon from "@public/img/search-black.svg";
import { Movie } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import PaginationView from "@/component/commom/pagination";
import LoadingGif from "@public/img/loading.gif";
import DashedAddIcon from "@public/img/dashed-add.svg";
import TrashIcon from "@public/img/trash.svg";
import { useParams } from "react-router-dom";
import { videoRepo } from "@/repo/video-repo";
import { ASSETS_BASE_URL } from "@/utils/constants";

function ListsEmptyIcon() {
    return (
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="profile-panel__empty-icon">
            <path d="M20.901 16.4727H16.932" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4009 3.46777V20.5318" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40089 3.46777V20.5318" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40099 16.4727H3.43199" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.901 12H16.527" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.473 12H6.57298" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40101 12H3.02701" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.9011 7.47266H16.9861" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40105 7.47266H3.48605" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3C16.2426 3 18.364 3 19.682 4.31802C21 5.63604 21 7.75736 21 12C21 16.2426 21 18.364 19.682 19.682C18.364 21 16.2426 21 12 21C7.75736 21 5.63604 21 4.31802 19.682C3 18.364 3 16.2426 3 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function Page() {
    var routeParams = useParams<{ id: string }>();
    var id = routeParams.id || "";
    var setNotification = useContext<AppContextType>(WonmovContext).setNotification;

    var listState = useState<ListData | null>(null);
    var list = listState[0];
    var setList = listState[1];
    var loadingState = useState<boolean>(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    var loadingMoviesState = useState<boolean>(false);
    var loadingMovies = loadingMoviesState[0];
    var setLoadingMovies = loadingMoviesState[1];
    var moviesState = useState<Movie[]>([]);
    var movies = moviesState[0];
    var setMovies = moviesState[1];
    var pageState = useState(1);
    var page = pageState[0];
    var setPage = pageState[1];
    var paginationState = useState<Pagination | null>(null);
    var pagination = paginationState[0];
    var setPagination = paginationState[1];
    var removingIdState = useState<number | null>(null);
    var removingId = removingIdState[0];
    var setRemovingId = removingIdState[1];

    useEffect(function () {
        if (isNaN(Number(id))) {
            setNotification({ type: "danger", message: "ID لیست معتبر نیست" });
            return;
        }
        getData(Number(id));
    }, [id]);

    useEffect(function () {
        if (list) {
            getMovies(list.id, page);
        }
    }, [list, page]);

    var getData = function (listId: number) {
        setLoading(true);
        userRepo.getList(listId).then(function (res) {
            setLoading(false);
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }
            setList(res.data ? res.data : null);
        });
    };

    var getMovies = function (listId: number, moviesPage: number) {
        setLoadingMovies(true);
        userRepo.getListMovies(listId, moviesPage, 12).then(function (res) {
            setLoadingMovies(false);
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }
            setMovies(res.data ? res.data : []);
            setPagination(res.pagination ? res.pagination : null);
        });
    };

    var addMovie = function (movie: Movie) {
        if (movies.length < 12) {
            setMovies(movies.concat([movie]));
            return;
        }

        if (pagination) {
            setPagination({
                has_more: pagination.has_more,
                next_page: pagination.next_page,
                previous_page: pagination.previous_page,
                current_page: pagination.current_page,
                per_page: pagination.per_page,
                total_items: pagination.total_items + 1,
                total_pages: pagination.total_pages + 1,
                limit: pagination.limit,
            });
        }
    };

    var removeMovie = function (movie: Movie) {
        if (removingId) {
            return;
        }
        setRemovingId(movie.id);
        userRepo.removeMovieFromList(list && list.id ? list.id : 0, movie.id).then(function (res) {
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                setRemovingId(null);
                return;
            }
            setRemovingId(null);
            setMovies(function (prev) {
                return prev.filter(function (m) {
                    return m.id !== movie.id;
                });
            });
        });
    };

    var bodyClassName = "profile-lists-detail__body";
    if (movies.length === 0) {
        bodyClassName = bodyClassName + " profile-lists-detail__body--center";
    }

    var showInitialLoading = (loading || loadingMovies) && movies.length === 0;
    var showEmpty = !loading && !loadingMovies && movies.length === 0;
    var showGrid = movies.length > 0;
    var showGridLoading = (loadingMovies || loading) && movies.length > 0;

    return (
        <div className="profile-panel profile-lists profile-lists-detail">
            <h2 className="profile-panel__title">ویرایش عناوین لیست</h2>

            {!loading && (
                <>
                    <SearchForm
                        listId={list && list.id ? list.id : 0}
                        onAdd={addMovie}
                    />
                    <div className="profile-lists__divider">
                        <span className="profile-lists__divider-label">عناوین موجود در لیست</span>
                        <div className="profile-lists__divider-line"></div>
                    </div>
                </>
            )}

            <div className={bodyClassName}>
                {showInitialLoading && (
                    <div className="profile-panel__loading">
                        <img src={LoadingGif} alt="Loading" />
                    </div>
                )}

                {showEmpty && (
                    <div className="profile-panel__empty">
                        <ListsEmptyIcon />
                        <p className="profile-panel__empty-title">
                            <span className="profile-panel__empty-title-accent">عنوانی</span> وجود ندارد
                        </p>
                        <p className="profile-panel__empty-desc">برای افزودن عنوان جدید جست و جو کنید.</p>
                    </div>
                )}

                {showGrid && (
                    <div className="profile-lists-movies">
                        {showGridLoading && (
                            <div className="profile-lists-movies__overlay">
                                <img src={LoadingGif} alt="Loading" />
                            </div>
                        )}
                        {movies.map(function (movie) {
                            return (
                                <div key={movie.id} className="profile-lists-movies__item">
                                    <ListMovieItem
                                        movie={movie}
                                        isLoading={removingId === movie.id}
                                        onRemove={function () {
                                            removeMovie(movie);
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {pagination && (
                <div className="profile-panel__pagination">
                    <PaginationView pagination={pagination} black={true} onChange={setPage} />
                </div>
            )}
        </div>
    );
}

function SearchForm({ listId, onAdd }: { listId: number; onAdd: (movie: Movie) => void }) {
    var queryState = useState("");
    var query = queryState[0];
    var setQuery = queryState[1];
    var resultsState = useState<Movie[]>([]);
    var results = resultsState[0];
    var setResults = resultsState[1];
    var isLoadingState = useState(false);
    var isLoading = isLoadingState[0];
    var setIsLoading = isLoadingState[1];
    var isAddingState = useState(false);
    var isAdding = isAddingState[0];
    var setIsAdding = isAddingState[1];
    var searchRequestId = useRef(0);
    var setNotification = useContext<AppContextType>(WonmovContext).setNotification;

    var search = function () {
        if (query.trim().length < 2 || isLoading || isAdding) {
            return;
        }

        var currentRequestId = searchRequestId.current + 1;
        searchRequestId.current = currentRequestId;

        setIsLoading(true);

        videoRepo.search({ s: query, page: 1, limit: 4 }).then(function (res) {
            if (searchRequestId.current !== currentRequestId) {
                return;
            }

            setIsLoading(false);

            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }

            setResults(res.data && res.data.movies ? res.data.movies : []);
        });
    };

    var addMovie = function (movie: Movie) {
        if (isAdding || isLoading) {
            return;
        }
        setIsAdding(true);
        userRepo.addMovieToList(listId, movie.id).then(function (res) {
            setIsAdding(false);
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }

            onAdd(movie);
            setResults([]);
            setQuery("");
            setIsLoading(false);
            searchRequestId.current = searchRequestId.current + 1;
        });
    };

    return (
        <div className="profile-lists-search">
            <div className="profile-lists-search__bar">
                <div className="profile-lists-search__input-wrap">
                    <TextField
                        name="search"
                        type="text"
                        placeholder="جستجو نام فیلم یا بازیگر یا IMDb ID و ..."
                        rootClassName="profile-lists-search__field"
                        value={query}
                        onChange={function (e) {
                            setQuery(e.target.value);
                        }}
                        onKeyDown={function (e) {
                            if (e.key === "Enter") {
                                search();
                            }
                        }}
                    />
                </div>
                <div className="profile-lists-search__btn-wrap">
                    <button type="button" className="profile-lists-search__btn" onClick={search}>
                        <img src={searchIcon} alt="جستجو" />
                    </button>
                </div>
            </div>

            {(isLoading || results.length > 0) && (
                <div className="profile-lists-search__dropdown">
                    {isLoading && (
                        <div className="profile-lists-search__dropdown-loading">
                            <img src={LoadingGif} alt="Loading" />
                        </div>
                    )}
                    {results.length > 0 && (
                        <div className="profile-lists-search__results">
                            {results.map(function (result) {
                                return (
                                    <div key={result.id} className="profile-lists-search__result">
                                        <SearchResultItem
                                            result={result}
                                            isLoading={isAdding}
                                            onAdd={function () {
                                                addMovie(result);
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

function SearchResultItem({ result, isLoading, onAdd }: { result: Movie; isLoading: boolean; onAdd: () => void }) {
    var poster = result.thumbnail && result.thumbnail.indexOf("http") === 0
        ? result.thumbnail
        : ASSETS_BASE_URL + (result.thumbnail ? result.thumbnail : "");

    return (
        <button type="button" className="profile-lists-search-item" onClick={onAdd}>
            <img src={poster} alt={result.title} className="profile-lists-search-item__poster" />
            <div className="profile-lists-search-item__info">
                <p className="profile-lists-search-item__title">{result.title}</p>
                <span className="profile-lists-search-item__year">{result.year}</span>
            </div>
            {!isLoading && <img src={DashedAddIcon} alt="اضافه کردن" className="profile-lists-search-item__add" />}
            {isLoading && (
                <div className="profile-lists-search-item__loader">
                    <div className="green-loader"></div>
                </div>
            )}
        </button>
    );
}

function ListMovieItem({ movie, isLoading, onRemove }: { movie: Movie; isLoading: boolean; onRemove: () => void }) {
    var poster = movie.thumbnail && movie.thumbnail.indexOf("http") === 0
        ? movie.thumbnail
        : ASSETS_BASE_URL + (movie.thumbnail ? movie.thumbnail : "");

    return (
        <div className="profile-lists-movie">
            <div className="profile-lists-movie__poster-wrap">
                <img src={poster} alt={movie.title} className="profile-lists-movie__poster" />
                {!isLoading && (
                    <button type="button" className="profile-lists-movie__remove" onClick={onRemove}>
                        <img src={TrashIcon} alt="حذف" />
                    </button>
                )}
                {isLoading && (
                    <div className="profile-lists-movie__remove-loader">
                        <div className="white-loader"></div>
                    </div>
                )}
            </div>
            <p className="profile-lists-movie__title">{movie.title}</p>
        </div>
    );
}
